import {
	SET_CELLGROUPS,
	SET_CELLGROUP,
	CLEAR_CELLGROUPS,
	CLEAR_CELLGROUP,
	ADD_CELLGROUP,
	UPDATE_CELLGROUP,
	REMOVE_CELLGROUP,
} from './actionTypes';

export const cellGroup = (state = {}, action) => {
	switch (action.type) {
		case SET_CELLGROUP:
			return action.payload;
		case UPDATE_CELLGROUP:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_CELLGROUP:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_CELLGROUPS:
			return action.payload;
		case ADD_CELLGROUP:
			return [...state, action.payload];
		case UPDATE_CELLGROUP:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_CELLGROUP:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_CELLGROUPS:
			return [];
		default:
			return state;
	}
};
